import { VpCarouselMethods } from '@ps/bridge/qc/vp/carousel'
const VpCategories = {
  carousel: 'Carousel Component',
}
export default {
  carouselAction: {
    [VpCarouselMethods.vpCarouselComponentEnable]: {
      label: 'Enable/Disable Carousel Component',
      category: VpCategories.carousel,
      paramFormConfig: {
        isEnable: {
          title: 'Enable/Disable',
          component: 'select',
          field: {
            options: [
              {
                label: 'Enable',
                value: true,
              },
              {
                label: 'Disable',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselEnable]: {
      label: 'Enable/Disable Carousel Groups',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: 'Enable/Disable',
          component: 'select',
          field: {
            options: [
              {
                label: 'Enable',
                value: true,
              },
              {
                label: 'Disable',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselPause]: {
      label: 'Pause/Play Carousel Group',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isPause: {
          title: 'Pause/Play',
          component: 'select',
          field: {
            options: [
              {
                label: 'Pause',
                value: true,
              },
              {
                label: 'Play',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselRestart]: {
      label: 'Restart carousel',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselDeleteResource]: {
      label: 'Delete carousel resources',
      category: VpCategories.carousel,
      paramFormConfig: {
        resourceIds: {
          title: 'Responsive Object',
          component: 'select-group',
          field: {
            options: [],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselSetStayTime]: {
      label: 'Dwell time',
      category: VpCategories.carousel,
      paramFormConfig: {
        stayTime: {
          title: 'Dwell time',
          component: 'input',
        },
      },
    },
  },
}
